module.exports = __webpack_public_path__ + "img/KSC09014.f8936721.jpg";